// extracted by mini-css-extract-plugin
module.exports =  {"FRAME":"FRAME","STACK":"STACK","GRID":"GRID","box":"box--pgS7m"};